/* tslint:disable */

/**
 */
export class EquipmentSeries {
    ID_EQUIPSERIES?: number;
    ID_FAMILY?: number;
    SERIES_NAME?: string;
    CONSTRUCTOR?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/equipment-series.ts